import React, { useCallback, useEffect, useMemo, useState } from "react";

import FormBtn from "app/Components/CommanComponents/FormBtn";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import ConfirmationModal from "./Component/ConfimationModal";
import { confirmAlert } from "react-confirm-alert";
import InputError from "app/Components/_form/InputError/InputError";
import {
  siteTypeList,
  siteTypeObj,
} from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import {
  getEmployeeByID,
  updateEmployeeCurrentLocationOfEmployee,
} from "app/_services/UserManagement/EmployeeService";
import { Card, Col, Row, FormGroup, Button, Dropdown } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import Label from "app/Components/_form/Label/Label";
import ViewBasicDetailsComponent from "./Component/ViewBasicDetailsComponent";
import {
  WidgetBox,
  employeeEmploymentStatusObj,
  employeeFormLabel,
  initialMedicalValidation,
  initialTrainingValidation,
} from "./Constant";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import toastr from "toastr";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";

import { DDMMYYYYFormat, disableFutureDate, isAfter } from "app/_helpers/dateHelper";

import LocationHistoryList from "./Component/LocationHistoryList";
import InitialTrainingForm from "./Component/InitialTrainingForm";
import InitialMedicalForm from "./Component/InitialMedicalForm";
import EmployeeId from "./Component/EmployeeId";
import ViewLocationForm from "./Component/ViewLocationForm";
import { BsThreeDotsVertical } from "react-icons/bs";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function EmployeeLocationForm() {
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  const { id } = useParams();
  const [siteList, setSiteList] = useState([]);
  const [initialForm, setInitialForm] = useState({});
  const history = useHistory();
  // Site History Modal
  const [siteHistoryList, setSiteHistoryList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const { goBack } = useHistory();
  const [confirmation, setConfirmation] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [loading, setLoading] = useState(false);

  /***************** useMemo ********************/
  const showTraining = useMemo(
    () => form.siteType === 3,
    // initialForm.siteType !== 3 &&
    //!form?.basicTrainingCompletionDate,
    [form.siteType]
  );

  const showMedical = useMemo(
    () =>
      form.siteType === 3 &&
      // initialForm.siteType !== 3 &&
      !form?.lastIMEDate,
    //!form?.lastPMEDate,
    [form?.lastIMEDate, form.siteType]
  );

  /***************** Api Call ********************/
  const getFormData = useCallback(
    async (qq) => {
      getEmployeeByID(id).then((response) => {
        if (!response?.status) {
          history.push("/user-management/employee");
          toastr.error(response?.message || "Something went Wrong");
          return;
        }
        if (!response?.data) return;
        const row = response.data.employees;

        setForm({
          ...row,
          siteType: row?.ehsSite?.siteType || "",
          isPmeDate: row?.isPmeDate ? true : false,
          isIMEDate: row?.isIMEDate ? true : false,
          pmeDate: row?.lastPMEDate,
          imeDate: row?.lastIMEDate,
          isRefresherDate: row?.isRefresherDate || false,
        });

        setInitialForm({
          ...response.data.employees,
          siteType: response.data.employees?.ehsSite?.siteType || "",
          isPmeDate: response.data.employees?.isPmeDate ? true : false,
          pmeDate: response.data.employees?.lastPMEDate,
        });

        setSiteHistoryList([
          {
            ...row,
            isPmeDate: row?.isPmeDate ? true : false,
            isIMEDate: row?.isIMEDate ? true : false,
            pmeDate: row?.lastPMEDate,
            imeDate: row?.lastIMEDate,
            sid: 1,
            siteName: row?.ehsSite?.name,
            startDateView: row?.startDateAtMines
              ? DDMMYYYYFormat(row?.startDateAtMines)
              : "",
            // endDateView: d.endDate ? DDMMYYYYFormat(d.endDate) : "",
            endDateView:
              row?.employmentStatus !== "active" && row?.dateOfSeparation
                ? DDMMYYYYFormat(row?.dateOfSeparation)
                : "",

            siteType: row?.ehsSite?.siteType || "",
            siteTypeView: siteTypeObj[row?.ehsSite?.siteType],
            siteId: row?.currentWorkLocation,
            currentWorkLocation: row?.currentWorkLocation,
            startDateAtMines: row?.startDateAtMines,
            startDate: row?.startDateAtMines,
          },
          ...(row?.employeeSiteHistories || []).map((d, i) => ({
            ...d,
            sid: i + 2,
            siteName: d?.ehsSiteForHistory?.name,
            startDateView: d.startDate ? DDMMYYYYFormat(d.startDate) : "",
            endDateView: d.endDate ? DDMMYYYYFormat(d.endDate) : "",
            siteTypeView: siteTypeObj[d?.ehsSiteForHistory?.siteType],
          })),
        ]);
      });
    },
    [id]
  );

  const getAllSiteList = useCallback(async () => {
    let response = await getAllSites("filter[status]=1");
    if (!response?.data || !response?.status) return;

    setSiteList(response.data);
  }, []);

  const onChange = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};
    if (name === "currentWorkLocation" && value !== form?.currentWorkLocation) {
      if (
        siteList
          .filter((d) => d.siteType === 3)
          .map((d) => d.id)
          .includes(+value)
      ) {
        if (!form?.lastIMEDate && !form?.lastPMEDate) {
          extraToChange.mineTag = "yes";
          extraToChange.trainingEligibility = "";
          extraToChange.trainingDesignation = "";
          // extraToChange.isPmeDate = false;
          // extraToChange.pmeDate = "";
          extraToChange.specialMedicalExamEligibility = "";
          extraToChange.specialMedicalExamCategory = "";
        } else extraToChange.mineTag = "yes";
      } else {
        extraToChange.mineTag = "no";
        extraToChange.startDateAtMines = "";
      }
    }

    if (name === "siteType" && value !== form?.siteType) {
      extraToChange.currentWorkLocation = "";
      extraToChange.startDateAtMines = "";
      extraToChange.endDateAtMines = "";
      extraToChange.mineTag = "no";
    }

    if (name === "trainingEligibility" && value !== "yes") {
      extraToChange.trainingDesignation = "";
    }

    if (name === "isPmeDate" && value !== form?.isPmeDate) {
      extraToChange.pmeDate = "";
      extraToChange.pmeCertificateNo = "";
      extraToChange.pmeCertificateId = null;
    }

    if (name === "isIMEDate" && value !== form?.isIMEDate) {
      extraToChange.imeDate = "";
      extraToChange.imeCertificateNo = "";
      extraToChange.imeCertificateId = null;
    }

    if (name === "specialMedicalExamEligibility" && value !== "yes") {
      extraToChange.specialMedicalExamCategory = "";
    }

    setForm((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  let query = "checkPreviousRecord=true";

  const onSubmit = useCallback(
    async (e, checkExisting = true) => {
      if (e) e.preventDefault();
      let errorObj = {};
      if (form.siteType) {
        if (!form.currentWorkLocation) {
          errorObj["currentWorkLocation"] =
            employeeFormLabel["currentWorkLocation"] + " is Required.";
        }
        if (!form.startDateAtMines)
          errorObj["startDateAtMines"] =
            employeeFormLabel["startDateAtMines"] + " is Required.";
        if (
          form?.dateOfJoining &&
          form?.startDateAtMines &&
          isAfter(form?.dateOfJoining, form?.startDateAtMines)
        ) {
          errorObj["startDateAtMines"] =
            employeeFormLabel["startDateAtMines"] +
            " Can't Before " +
            employeeFormLabel["dateOfJoining"];
        }
      } else {
        errorObj["siteType"] = employeeFormLabel["siteType"] + " is Required.";
      }
      if (showTraining) {
        errorObj = initialTrainingValidation(errorObj, form);
      }
      if (form.siteType === 3) {
        errorObj = initialMedicalValidation(errorObj, form);
      }
      setError((prev) => ({
        ...errorObj,
      }));
      if (Object.values(errorObj).filter((d) => d !== "").length) return;
      setLoading(true);
      let formObj = JSON.parse(JSON.stringify(form));
      formObj.trainingType = 1;
      let response = {};
      if (checkExisting) {
        response = await updateEmployeeCurrentLocationOfEmployee(
          id,
          {
            employee: formObj,
          },
          query
        );
      } else {
        response = await updateEmployeeCurrentLocationOfEmployee(id, {
          employee: formObj,
        });
      }
      if (response?.data?.existingData) {
        setConfirmMsg(response?.data?.existingData);
        setConfirmation(true);
        setLoading(false);
        return;
      } else {
        setConfirmation(false);
      }
      if (!response?.status) {
        setLoading(false);
        return toastr.error(response?.message);
      }
      setLoading(false);
      toastr.success(response.message || "Success.");
      getFormData();
    },
    [form, getFormData, id, showTraining]
  );

  /*********************** useEffect ***************************/
  useEffect(() => {
    getAllSiteList();
  }, [getAllSiteList]);

  useEffect(() => {
    if (!id) return;

    getFormData(1);
  }, [getFormData, id]);

  const onHideConfirmation = () => {
    setConfirmation(false);
  };
  const confirmationAlert = useCallback(() => {
    confirmAlert({
      title: "Change location",
      message: "Are you sure you want to proceed with location update",
      buttons: [
        {
          label: "Yes",
          onClick: (e) => {
            onSubmit(e, false);
          },
        },
        {
          label: "No",
          onClick: () => {
            setConfirmation(false);
          },
        },
      ],
    });
  }, [onSubmit]);

  return (
    <div>
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title justify-content-between">
            <h3 class="text-capitalize mb-1">Edit location</h3>

            <EmployeeId id={id} form={initialForm} employeeId={form.employeeId} />
          </Card.Title>

          <WidgetBox form={initialForm} />
          <ViewBasicDetailsComponent form={form} />
          <ViewLocationForm form={initialForm} />

          {isActive ? (
            <>
              {!loading ? (
                <>
                  <div className="mt-2">
                    <h5>New Location</h5>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label>{employeeFormLabel["siteType"]}</Label>

                          <SimpleSelect
                            name={"siteType"}
                            value={form.siteType}
                            onChange={onChange}
                            options={siteTypeList}
                            label={"name"}
                            id="value"
                            placeHolder={employeeFormLabel["siteType"]}
                            error={error["siteType"]}
                          />
                          <InputError error={error["siteType"]} />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label>{employeeFormLabel["currentWorkLocation"]}</Label>

                          <SimpleSelect
                            name={"currentWorkLocation"}
                            value={form.currentWorkLocation}
                            onChange={onChange}
                            options={
                              form.siteType
                                ? siteList
                                    .filter((d) => d.siteType === +form.siteType)
                                    .map((d) => ({
                                      name: `${d.name}`,
                                      value: d.id,
                                    }))
                                : []
                            }
                            label={"name"}
                            disabled={!form.siteType}
                            id="value"
                            placeHolder={employeeFormLabel["currentWorkLocation"]}
                            error={error["currentWorkLocation"]}
                          />
                          <InputError error={error["currentWorkLocation"]} />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>{employeeFormLabel["startDateAtMines"]}</Label>

                          <DatePicker
                            name={"startDateAtMines"}
                            value={form.startDateAtMines}
                            onChangeDate={onChange}
                            label={employeeFormLabel["startDateAtMines"]}
                            placeHolder={employeeFormLabel["startDateAtMines"]}
                            error={error["startDateAtMines"]}
                            disabled={!form.siteType}
                            isValidDate={disableFutureDate}
                          />
                          <InputError error={error["startDateAtMines"]} />
                        </FormGroup>
                      </Col>

                      <Col md={1}>
                        <FormGroup>
                          <Label>{employeeFormLabel["mineTag"]}</Label>

                          {/* <FormCheckbox
                    type="checkbox"
                    // name="permanentDisability"
                    checked={form.mineTag === "yes"}
                    disabled
                    // onChange={onChange}
                    // label={"Fatality/permanent loss of body part or permanent disability"}
                  /> */}
                          <span>{form.mineTag === "yes" ? "YES" : "NO"}</span>
                          <InputError error={error["mineTag"]} />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  {!form?.lastIMEDate && !form?.lastPMEDate && (
                    <>
                      {showTraining && (
                        <InitialTrainingForm
                          form={form}
                          onChange={onChange}
                          error={error}
                        />
                      )}

                      {form.siteType === 3 && (
                        <InitialMedicalForm
                          showMedical={showMedical}
                          form={form}
                          onChange={onChange}
                          error={error}
                        />
                      )}
                    </>
                  )}
                  <FormBtn
                    id={id}
                    backBtnTitle={"Cancel"}
                    onSubmit={onSubmit}
                    backOnClick={() => setIsActive(false)}
                  />
                </>
              ) : (
                <NetZeroLoader addZIndex={true} />
              )}
            </>
          ) : (
            <div className={"mt-4 text-center"}>
              <Button onClick={goBack} variant="secondary" className="mr-2">
                {"Back"}
              </Button>

              <Button
                onClick={() => setIsActive(true)}
                variant="primary"
                className="ml-2"
              >
                {"Move Location"}
              </Button>
            </div>
          )}

          <LocationHistoryList
            data={siteHistoryList}
            getFormData={getFormData}
            siteList={siteList}
          />
        </Card.Body>
      </Card>
      {!loading ? (
        <ConfirmationModal
          confirmation={confirmation}
          onHideConfirmation={onHideConfirmation}
          confirmMsg={confirmMsg}
          confirmationAlert={confirmationAlert}
          title={"Location Change Confirmation"}
          type={"location"}
          modalFor={"employee"}
          checkMedicalForPending={true}
        ></ConfirmationModal>
      ) : (
        ""
      )}
    </div>
  );
}

export default EmployeeLocationForm;
